import * as paymentContractsEn from './payment-contracts/en.json';
import * as advancementOptionsEn from './advancements-options/en.json';
import * as sellerEn from './seller/en.json';
import * as paymentContractsHe from './payment-contracts/he.json';
import * as advancementOptionsHe from './advancements-options/he.json';
import * as sellersHe from './seller/he.json';

export const getEnTranslation = (): any => {
  return { ...paymentContractsEn, ...advancementOptionsEn, ...sellerEn };
};

export const getHeTranslation = (): any => {
  return { ...paymentContractsHe, ...advancementOptionsHe, ...sellersHe };
};
